import { ErrorType } from "./types";



export function getErrorTypeFromStatus(status: number): ErrorType | null {
  if (status === 403) {
    return ErrorType.ERROR_403;
  }

  if (status === 404) {
    return ErrorType.ERROR_404;
  }

  if (status === 500) {
    return ErrorType.ERROR_500;
  }

  return null;
}

export function getErrorTypeFromHttpResponse(response: Response): ErrorType | null {
  return getErrorTypeFromStatus(response.status);
}
